import React from 'react';
import MicrosoftButton from '../ui/MicrosoftButton';
import useResolver from '../hooks/useResolver';
import AccountStore, { SocialLoginProvider } from '../store/AccountStore';
import useToast from '../hooks/useToast';

export interface ConnectedMicrosoftLoginProps {}

const ConnectedMicrosoftLogin: React.FC<ConnectedMicrosoftLoginProps> = () => {
  const accountStore = useResolver(AccountStore);
  const toast = useToast();

  return (
    <MicrosoftButton
      onClick={() =>
        accountStore.socialLogin(SocialLoginProvider.MICROSOFT).catch((e) =>
          toast({
            status: 'error',
            title: 'Sign in failed',
            description: e.message,
          }),
        )
      }
    />
  );
};

export default ConnectedMicrosoftLogin;
